<template>
  <div class='messages-view'>
    <div class='app-columns'>
      <Sidebar @start="startChallenge($event)" current='messages' ref="sidebar"></Sidebar>
      <div class='sections'>
        <div class='section-title section-header'>Your Messages<span class="badge left-space" v-if="messages.unread()">{{messages.unread()}}</span></div>
        <div @click="showMessageId(msg.id)" class='msg' :viewed="msg.read" :active="selectedMessage && msg.icon==selectedIcon && msg.read==true" :status="msg.status" v-for="msg in messageHeaders" :key="msg.id">
          <div :class="['msg-icon',msg.icon]">{{msg.from.charAt(0)}}</div>
          <div class='msg-content'>
            <div class='msg-title'>{{msg.from}}</div>
            <div class='msg-desc'>
              {{msg.subject}} {{msg.content[0]}}
            </div>
          </div>
        </div>
      </div>
      <div class='content'>
        <div class='content-header' v-if="current" >
          <div class="sender-label">
            <div :class="['msg-icon',current.icon]">{{current.from.charAt(0)}}</div>
            <span>{{current.from}}</span>
          </div>
        </div>
        <div class='content-messages' v-if="current" >
          <div @click="selectMessage(current,true)" :class="['message-item',selectedMessage==current.id&&current.read?'current-message':null]">
            <p class="message-title" v-if="current.subject" :hascontent="current.content && current.content.length>0">{{current.subject}}</p>
            <p v-for="(line,idx) in current.content" :key="idx">
              <span v-if="!line.buttons" v-html="line" ></span>
              <span class="message-buttons" v-if="line.buttons">
                <button v-for="(bt,idx) in line.buttons" :key="bt" :idx="idx" class="action-button action-small action-disabled" :class="{'selected-button': simulation.defaultActiveAnalytics.includes(idx)}" :disabled="simulation.started" @click="messageButton($event, bt, current)">{{bt}}</button>
                <hr v-if="!simulation.started">
              </span>
            </p>
            <div class='message-toolbar'>
              <button @click="btnLink(btn)" v-for="(btn,btnidx) in current.buttons" :class="[{'started': simulation.started}, 'action-button', btn.className, 'action-small']" :key="btnidx">{{btn.label}}</button>
            </div>
          </div>
          <div class='message-footer' :pending="prevMessages.length">
            <div class='message-time'>{{messageTime(current.time)}}</div>
          </div>
          <div v-for="prev in prevMessages" :key="prev.id">
            <div @click="selectMessage(prev,true)" :class="['message-item',selectedMessage==prev.id?'current-message':null]" >
              <p class="message-title" :hascontent="prev.content && prev.content.length>0">{{prev.subject}}</p>
              <p v-for="(line,idx) in prev.content" :key="idx" >
                <span v-if="!line.buttons" v-html="line" ></span>
                <span class="message-buttons" v-if="line.buttons">
                  <button v-for="(bt,idx) in line.buttons" :key="bt" :idx="idx" class="action-button action-small action-disabled" :class="{'selected-button': simulation.defaultActiveAnalytics.includes(idx)}" :disabled="simulation.started" @click="messageButton($event, bt, current)">{{bt}}</button>
                  <hr v-if="!simulation.started">
                </span>
              </p>
              <div class='message-toolbar'>
                <button @click="btnLink(btn)" v-for="(btn,btnidx) in prev.buttons" :class="[{'started': simulation.started}, 'action-button', btn.className, 'action-small']" :key="btnidx">{{btn.label}}</button>
              </div>
            </div>
            <div class='message-footer' v-if="prev">
              <div class='message-time'>{{messageTime(prev.time)}}</div>
              <div class='message-seen'>Seen</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from '@/views/app/Sidebar.vue'
import messages from '@/lib/messages.js'
import simulation from '@/lib/simulation.js'

export default {
  name: 'messages',
  data: function () {
    return {
      currentIndex: -1,
      current: null,
      currentPump: null,
      messages: messages,
      messageList: messages.list,
      selectedMessage: null,
      selectedIcon: null,
      messageCount: 0,
      simulation: simulation
    }
  },
  components: {
    Sidebar
  },
  updated: function () {
    if (this.messageCount < messages.list.length) {
      if (messages.list.length > 1) {
        this.showMessage(0)
        this.selectMessage(messages.list[0])
      }
    }
    this.messageCount = messages.list.length
  },
  mounted: function () {
    this.currentPump = this.pump
    messages.deliverMessages(0)
    this.showMessage(0)
    const self = this
    messages.addMessageListener(function (msg) {
      if (self) {
        if (msg === null) {
          messages.deliverMessages(0)
          self.showMessage(0)
        }
        self.$forceUpdate()
      }
    })
    window.msg = messages
  },
  methods: {
    nextMessage: function () {
      this.currentIndex++
      if (this.currentIndex > this.messages.list.length) {
        this.currentIndex = -1
      }
      this.showMessage(this.currentIndex)
    },
    showMessage: function (idx) {
      this.currentIndex = idx
      this.current = this.messages.list[idx]
    },
    messageButton: function ($event, bt, message) {
      const el = $event.target
      el.classList.toggle('selected-button')
      const elements = document.querySelectorAll('button.selected-button')
      if (message.buttons && message.buttons[0]) {
        const bt = message.buttons[0]
        if (bt.label === 'Purchase Analytics' && elements.length === 0) {
          bt.label = 'Continue'
        }
        if (bt.label === 'Continue' && elements.length > 0) {
          bt.label = 'Purchase Analytics'
        }
      }
    },
    showMessageId: function (id) {
      for (const idx in messages.list) {
        const msg = messages.list[idx * 1]
        if (msg.id === id) {
          this.showMessage(idx)
          this.selectMessage(messages.list[idx * 1], true)
        }
      }
    },
    selectMessage: function (msg, read) {
      this.selectedMessage = msg.id
      this.selectedIcon = msg.icon
      if (read) {
        msg.read = true
      }
    },
    startTutorial: function () {
      this.$emit('action', { action: 'start', challenge: 0 })
    },
    skipTutorial: function () {
      this.$emit('action', { action: 'skipTutorial', challenge: 1 })
    },
    startChallenge: function (ch) {
      this.$emit('action', { action: 'start', challenge: ch })
    },
    goToChallenge: function (btn) {
      simulation.clear()
      this.$router.push('/challenge/' + btn.challenge + '/pumpcontrol')
      const self = this
      setTimeout(function () {
        self.showMessage(0)
        self.$forceUpdate()
      }, 500)
    },
    purchaseAnalyticsCh2: function (btn) {
      const pumps = document.querySelectorAll('button.selected-button')
      const active = []
      for (let idx = 0; idx < pumps.length; idx++) {
        const pumpIdx = pumps[idx].getAttribute('idx') * 1
        active.push(pumpIdx)
      }
      this.$emit('action', { action: 'start', challenge: 2, analytics: active })
      simulation.defaultActiveAnalytics = active
    },
    purchaseAnalyticsCh3: function (btn) {
      const pumps = document.querySelectorAll('button.selected-button')
      const active = []
      for (let idx = 0; idx < pumps.length; idx++) {
        const pumpIdx = pumps[idx].getAttribute('idx') * 1
        active.push(pumpIdx)
      }
      this.$emit('action', { action: 'start', challenge: 3, analytics: active })
      simulation.defaultActiveAnalytics = active
    },
    btnLink: function (btn) {
      const params = this.$router.history.current.params
      if (btn.reset && this.currentPump) {
        this.currentPump.clear()
      }
      if (btn.action && this[btn.action]) {
        this[btn.action](btn)
      } else if (btn.link) {
        this.$router.push('/challenge/' + params.number + '/' + btn.link)
      } else if (btn.route) {
        this.$router.push(btn.route)
      }
    },
    messageTime: function (time) {
      const minutes = Math.round(time / 60)
      const hours = Math.floor(minutes / 60)
      let hr = hours % 12
      let amPm = 'am'
      let min = minutes % 60
      if (min < 10) {
        min = '0' + min
      }
      if (hours === 0) {
        hr = 12
      }
      if (hours > 12) {
        amPm = 'pm'
      }
      return hr + ':' + min + ' ' + amPm
    }
  },
  computed: {
    prevMessages: function () {
      const currentid = this.current.id
      const currenticon = this.current.icon
      const pmessages = []
      let found = false
      for (const idx in messages.list) {
        if (found && messages.list[idx * 1] && currenticon === messages.list[idx * 1].icon) {
          pmessages.push(messages.list[idx * 1])
          messages.list[idx * 1].read = true
        }
        if (messages.list[idx].id === currentid) {
          found = true
        }
      }
      return pmessages
    },
    messageHeaders: function () {
      const hmessages = []
      const hicons = []
      for (const idx in messages.list) {
        const msg = messages.list[idx * 1]
        if (hicons.indexOf(msg.icon) === -1) {
          hmessages.push(msg)
          hicons.push(msg.icon)
        }
      }
      return hmessages
    }
  },
  props: {
    pump: Object,
    active: Boolean
  },
  watch: {
    pump: function (newValue) {
      this.currentPump = newValue
    },
    active: function (newValue) {
      if (newValue && this.current && this.current.icon === this.messages.list[0].icon) {
        this.showMessage(0)
      }
    }
  }
}
</script>

<style scoped lang='scss'>
.messages-view {
  height: 100%;
}
.msg-icon {
  user-select: none;
  width: 38px;
  height: 38px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 38px;
  background-color: #ccc;
  margin-right: 10px;
  border-radius: 2px;
  color: #fff;
  font-weight: bold;
  font-size: 24px;
  &.icon-supervisor {
    background-color: #af0671;
  }
  &.icon-pumpengineer {
    background-color: #6BAF06;
  }
  &.icon-mayor {
    background-color: #003A78;
  }
  &.icon-itmanager {
    background-color: #ffcc01;
  }
}
.app-columns {
  .sections {
    background-color: #fff;
    width: 216px;
    text-align: left;
    overflow-y: auto;
    .section-title {
      text-transform: uppercase;
      font-weight: bold;
      margin: 16px 0 16px 16px;
      padding: 2px 0 13px 0;
      border-bottom: 2px solid #ccc;
      font-size: 14px;
      line-height: 22px;
      height: 39px;
    }
    .msg {
      margin: 16px;
      padding: 10px;
      display: flex;
      border-radius: 5px;
      border: 2px solid #00b5e240;
      background-color: #F1F9FF;
      transition: border linear .1s, box-shadow 0.2s;
      font-size: 14px;
      color: #222;
      &[viewed='true']{
        border: 2px solid #f1f9ff;
      }
      &:hover{
        border: 2px solid #00b5e280;
        cursor: pointer;
        box-shadow: 0px 3px 6px #00000029;
      }
      .msg-title {
        font-weight: bold;
        text-transform: uppercase;
        margin-bottom: 4px;
      }
      .msg-desc{
        max-height: 3.6em;
        overflow: hidden;
        line-height: 1.2em;
      }
      &[status='hidden'] {
        display: none;
      }
      &[active='true']{
        background-color: #f1f9ff;
        border: 2px solid #00b5e2;
      }
      &[viewed='true']{
        color: #666;
        background-color: #ffffff;
      }
    }
  }
  .content {
    background-color: #f1f9ff;
    flex: 1;
    text-align: left;
    overflow-y: auto;
    .content-header {
      text-transform: uppercase;
      font-weight: bold;
      padding: 0 16px 8px 0;
      margin: 0;
      font-size: 14px;
      position: sticky;
      top: 0px;
      background-color: #f1f9ff;
      .sender-label{
        border-bottom: 2px solid #ccc;
        padding: 7px 0 8px 16px;
      }
    }
    .content-messages {
      margin: 8px 16px 16px 16px;
      .message-item {
        background-color: #fff;
        border-radius: 5px;
        padding: 16px 16px 12px 16px;
        padding-top: 0;
        border: 2px solid #f1f9ff;
        transition: border linear .1s, box-shadow 0.2s;
        &:hover{
          border: 2px solid #00b5e240;
          cursor: pointer;
          box-shadow: 0px 3px 6px #00000029;
        }
        &.current-message{
          border: 2px solid #00b5e2;
          cursor: default;
        }
        p[hascontent='true']{
          font-weight: bold;
          font-size: 16px;
        }
        p {
          margin: 12px 0;
          font-size: 14px;
          line-height: 18px;
          &::v-deep button {
            margin-bottom:8px;
          }
        }
        .message-toolbar > button{
          margin-right: 12px;
          margin-bottom: 0px;
        }
        .message-toolbar button.started.hide-on-start{
          display: none;
        }
        .message-buttons{
          display: block;
          text-align: center;
          > button{
            margin-right: 1vh;
            margin-bottom: 0px;
          }
          > button:last-child{
            margin-right: 0;
          }
           hr{
            margin: 12px 0;
          }
        }
      }
      .message-footer {
        font-weight: bold;
        font-size: 14px;
        margin-bottom: 20px;
        display: flex;
        justify-content: space-between;
        > div {
          line-height: 1.5em;
        }
        .message-seen{
          font-style: italic;
        }
        &[pending='0']{
          margin-bottom: 0px;
        }
      }
    }
  }
  .purchase-button{
    margin: 0 auto !important;
    display: block;
  }
}
p > .action-button{
  margin-right: 6px;
}
button[disabled="disabled"] {
  opacity: 0.5;
  pointer-events: none;
}
@media (max-height: 840px) {
  .app-columns .sections{
    min-width: 180px;
    width: 180px;
    .msg{
      margin: 12px;
      padding: 8px;
    }
    .section-title {
      height: 38px;
    }
  }
  .app-columns .content{
    .content-header .sender-label{
      padding: 9px 0 11px 12px;
    }
    .content-messages{
      margin: 2px 12px 12px 12px;
      .message-item{
        padding: 12px;
        padding-top: 0;
        p{
          margin:12px 0 8px 0;
          font-size: 12px;
          line-height: 16px;
        }
      }
      .message-toolbar>button{
        margin-top: 4px;
      }
    }
  }
  .msg-icon{
    width: 32px;
    height: 32px;
    flex: 0 0 32px;
    margin-right: 8px;
  }
  .app-columns .content .content-messages .message-footer{
    font-size: 12px;
  }
}
@media (max-height: 700px){
  .app-columns .sections{
    min-width: 170px;
    width: 170px;
  }
  .app-columns .sections .msg{
    font-size: 12px;
  }
  .app-columns .content .content-messages .message-item p{
    margin: 6px 0 6px 0;
  }
  .msg-icon{
    font-size: 20px;
  }
}
@media (max-height: 660px){
  .app-columns .sections{
    min-width: 158px;
    width: 158px;
  }
  .app-columns .sections .msg{
    font-size: 11px;
  }
  .app-columns .content .content-messages{
    margin: 2px 8px 2px 8px;
  }
  .app-columns .content .content-messages .message-item{
    padding: 8px;
    padding-top: 2px;
    p[hascontent=true]{
      font-size: 12px;
      margin: 4px 0 4px 0 !important;
    }
    .message-buttons > button{
      margin-right: 4px;
    }
  }
  .app-columns .content .content-messages .message-item .message-buttons{
    display: flex;
    justify-content:center;
  }
}
@media (max-height: 600px){
  .app-columns .sections .msg{
    font-size: 10px;
  }
  .app-columns .content .content-messages .message-item p{
    font-size: 10px;
    line-height: 14px;
  }
  .app-columns .content .content-header .sender-label{
    padding-top: 6px;
    padding-bottom: 8px;
    font-size: 12px;
  }
  .app-columns .content .msg-icon{
    width: 24px;
    height: 24px;
    font-size: 14px;
  }
}
</style>
